import { Fragment } from 'react';
import { NavLink as RouterLink, useLocation, useMatches } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';



const StyledPageBreadcrumbs = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'breadcrumbsAlign',
})(
  ({ breadcrumbsAlign, theme }) => ({
    marginBottom: theme.spacing(2.5),
    '& .MuiBreadcrumbs-ol': {
      justifyContent: breadcrumbsAlign
    }
}));

function PageBreadcrumbs({ breadcrumbsAlign = 'flex-start' }) {
    const matches = useMatches();
  
    const crumbs = matches
      // first get rid of any matches that don't have handle and crumb
      .filter((match) => Boolean(match.handle?.crumb))
      // now map them into an array of elements, passing the loader
      // data to each one Boolean(match.params?.category)
      .map((match) => match.handle?.crumb(match.data, match.params));
  
    return (
        <StyledPageBreadcrumbs className="Sim-page-breadcrumbs" breadcrumbsAlign={breadcrumbsAlign}>
            {_.map(crumbs || [], (crumb, index) => (<Fragment key={index}>{crumb}</Fragment>))}
        </StyledPageBreadcrumbs>
    )
  };

export default PageBreadcrumbs;
